import { SummaryImportTypes } from './actionTypes';

const INIT_STATE = {
  listData: [],
  error: {},
  success: '',
  CountItems: 0,
  filterItems: [],
  loading: false,
};

const SummaryImport = (state = INIT_STATE, action: any) => {
  switch (action.type) {

    case SummaryImportTypes.GET_FILTER_LIST:
      return { ...state,
         loading: true 
        };

      case SummaryImportTypes.GET_FILTER_LIST_SUCCESS:
      return {
        ...state,
        listData: action.payload.listData,
        CountItems: action.payload.CountItems,
        loading: false,
      };

      case SummaryImportTypes.GET_FILTER_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
        listData: [],
        loading: false,
      };



      //-----------------------filter--------------------------------
    case SummaryImportTypes.GET_FILTERS:
      state = { ...state,
         loading: true 
        };
      break;
    
    case SummaryImportTypes.GET_FILTERS_SUCCESS:
      return {
        ...state,
        filterItems: action.payload.filterItems,
        loading: false,
      };

      case SummaryImportTypes.GET_FILTERS_ERROR:
        return {
          ...state,
          error: action.payload,
          listData: [],
          loading: false,
        };
  




    default:
      break;
  }

  return state;
};

export default SummaryImport;
